import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const hplcMethodTransferTool: Tool = {
  id: "hplc-method-transfer",
  name: () => m.hplc_tool_name(),
  description: () => m.hplc_tool_description(),
  icon: "⚗️",
  basePath: "/hplc-method-transfer",
  status: "stable",
  tags: [
    "science",
    "chemistry",
    "chromatography",
    "hplc",
    "hplc-method-transfer",
  ],
};
